import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'LegalStatus';
const ENDPOINT = `/legal-status/`;

@Injectable({
    providedIn: 'root'
})
export class LegalStatusService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
